import React, { useState } from "react";
import "./LiveClasses.scss";
import SearchLiveClasses from "../components/SearchLiveClasses";
import CalendarLiveClasses from "../components/CalendarLiveClasses";

const LiveClasses = () => {
  const [category, setCategory] = useState("");  // State for selected category
  const [searchTerm, setSearchTerm] = useState("");  // State for search term
  const [categories, setCategories] = useState([]); // State for storing categories

  // Function to handle search and update the state
  const handleSearch = (newCategory, newSearchTerm) => {
    setCategory(newCategory);
    setSearchTerm(newSearchTerm);
    //console.log("Category in LiveClasses:", newCategory);
    //console.log("Search Term in LiveClasses:", newSearchTerm);
  };

  return (
    <div className="live-classes-container">
      <h2>Live Classes</h2>
      <div className="divider"></div>

      {/* Render SearchLiveClasses here only */}
      <SearchLiveClasses onSearch={handleSearch} categories={categories} />
      
      {/* Pass the category, searchTerm, and setCategories to CalendarLiveClasses */}
      <CalendarLiveClasses 
        category={category} 
        searchTerm={searchTerm} 
        setCategories={setCategories} 
      />
      
      <div className="padding-bottom"></div>
    </div>
  );
};

export default LiveClasses;
